<template lang="pug">
  #business-list
    .table-view
      .table-view-header
        .table-view-header-title
          h3 Empresas
        .table-view-header-actions
          b-button.btn-create.boton(@click="showCreateModal()" size="sm" variant="secondary") + Nuevo
      b-table(:items="tableItems", :fields="fields", head-row-variant="light-primary", thead-tr-class="custom-table-head" responsive)
        template(v-slot:cell(RUT)="{value}")
          div(style="min-width: 130px;") {{value}}
        template(v-slot:cell(Inicio_contrato)="{value}")
          div(style="min-width: 100px;") {{value}}
        template(v-slot:cell(Acciones)="data")
          .table-actions
            b-button(@click="goToDetails(data.value.business)", size="sm", variant="light" style="color: #7F828F")
              font-awesome-icon(:icon="['far', 'edit']" size="lg")
            b-button(@click="showDeleteModal(data.value.business)", size="sm", variant="light" style="color: #7F828F")
                font-awesome-icon(:icon="['far', 'trash-alt']" size="lg")
    //- Modales
    b-modal(v-model="showCreate", size="lg", :hide-footer="true", title="Crear Empresa" no-close-on-backdrop)
      create-edit-form(v-if="showCreate", action="create", :hideModal="hideCreateModal", :makeToast="makeToast")
    b-modal(v-model="showDelete", :hide-footer="true", title="Eliminar Empresa" no-close-on-backdrop)
      delete-business(v-if="showDelete", :hideModal="hideDeleteModal", :selectedBusiness="selectedBusiness", :makeToast="makeToast")
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import CreateEditForm from './CreateEditForm';
import DeleteBusiness from './DeleteBusiness';
export default {
  components: {
    CreateEditForm,
    DeleteBusiness
  },
  data() {
    return {
      showCreate: false,
      showDelete: false,
      selectedBusiness: null,
      fields: [
        {
          key: 'Nombre',
          sortable: true
        },
        {
          key: 'Razon social',
          sortable: true
        },
        {
          key: 'RUT',
          sortable: true
        },
        {
          key: 'Inicio_contrato',
        },
        {
          key: 'Representante Legal',
          sortable: true
        },
        {
          key: 'Contacto',
        },
        {
          key: 'Acciones',
        }
      ]
    }
  },
  async created() {
    await this.listBusiness({ params: { userId: this.user.id }});
  },
  computed: {
    ...mapGetters(['businesses']),
    ...mapGetters('AuthenticationStore', ['user']),
    tableItems(){
      if (this.businesses) {
        return this.businesses.map((b) => {
          return {
            'Nombre': b.name,
            'Razon social': b.razonSocial,
            'RUT': b.rut,
            'Inicio_contrato': new Date(b.startContract).toLocaleDateString('es-CL', { timeZone: 'UTC' }),
            'Representante Legal': b.legalRepresentative,
            'Contacto': b.contact,
            'Acciones': { business: b }
          }
        })
      }
      return [];
    },
  },
  methods: {
    ...mapActions(['listBusiness']),
    showCreateModal() {
      this.showCreate = true;
    },
    goToDetails(business){
      this.$router.push({name: 'BusinessDetail', params: { id: business.id}});
    },
    showDeleteModal(business){
      this.selectedBusiness = business;
      this.showDelete = true;
    },
    async hideCreateModal() {
      this.showCreate = false;
      await this.listBusiness();
    },
    async hideDeleteModal() {
      this.showDelete = false;
      await this.listBusiness();
    },
    makeToast(variant=null, body, title) {
      this.$bvToast.toast(
        body,
        {
          title,
          variant,
          solid: true,
          hide: true,
          autoHideDelay: 3000
        }
      )
    }
  }
}
</script>

<style lang="scss" scoped>

#business-list {  
  margin-top: 20px;
  #addButton {
    margin-bottom: 20px;
  }
  .tableButton {
    margin-right: 5px;
  }
}
</style>